import { Component, OnInit, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { NoticiaDetalhesPage } from '../noticia-detalhes/noticia-detalhes.page';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { CommonModule } from '@angular/common';
import { ImagePipe } from 'src/app/pipes/image/image';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';

@Component({
  selector: 'app-list-image-peq',
  templateUrl: './list-image-peq.component.html',
  styleUrls: ['list-image-peq.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    ImagePipe,
    DateFormatPipe
  ]
})
export class ListImagePeqComponent implements OnInit {
  @Input()
  config: any;
  constructor(public modalCtrl: ModalController) { }

  ngOnInit() {
  }

  async abrirNoticia() {
    let modalPage = await this.modalCtrl.create({ component: NoticiaDetalhesPage, componentProps: { 'id': this.config.id } });
    modalPage.present();
  }
}
